import type { Dispatch, SetStateAction } from 'react';
import { createContext } from 'react';

export type SegmentChatContextType = {
  segmentChatStatus: boolean;
  setSegmentChatStatus: Dispatch<SetStateAction<boolean>>;
  segmentIconUrl: string | null | undefined;
  setSegmentIconUrl: Dispatch<SetStateAction<string | null | undefined>>;
  segmentIconsCache: Record<string, string | undefined>;
  setSegmentIconsCache: Dispatch<SetStateAction<Record<string, string | undefined>>>;
};

export const SegmentChatContext = createContext<SegmentChatContextType>({
  segmentChatStatus: false,
  setSegmentChatStatus: () => {},
  segmentIconUrl: undefined,
  setSegmentIconUrl: () => {},
  segmentIconsCache: {},
  setSegmentIconsCache: () => {},
});
